import React from "react";
import SectionHeadingBadge from "../../components/badges/SectionHeadingBadge";
import { Card } from "react-bootstrap";
import email from '../../assets/icons/email.svg';
import phone from '../../assets/icons/phone.svg';
import socialIcon from '../../assets/icons/socialMedia.svg'

function ContactUs() {
    const contactInfo = [
        {
          type: "Email",
          value: "connect@geesez.com",
          icon: email
        },
        {
          type: "Phone",
          value: "+91 95666 20220",
          icon: phone
        },
        {
          type: "Social Media",
          values: ["LinkedIn", "Twitter"],
          icon: socialIcon,
        },
      ];
  return (
    <div className="container d-flex flex-column justify-content-center mb-5 align-items-center gap-3">
      <SectionHeadingBadge text="Let’s connect" />
      <h1 className="text-white oswald-Bold font-48 text-transform-uppercase text-center">
        Have a Vision? Let's Make it a Reality.
      </h1>
      <p className="font-14 poppins-light color-theme-sub text-center w-45">
        Whether you're an established enterprise looking to innovate or a
        visionary founder with a bold new idea, our team is ready to partner
        with you. Let's discuss how we can adapt the world's best ideas to build
        your next success story, right here in India.
      </p>

      <Card  className="rounded border-none bg-dark px-3 py-4 w-100">
         
            <div className="mx-auto gap-3 px-5 py-3 ">
              <h3 className="poppins-semibold text-white text-base font-16 text-left py-3">
                Get in Touch
              </h3>

              <div className="d-flex flex-wrap justify-content-between gap-5 ">
                {contactInfo.map((info, index) => (
                  <div key={index} className="d-flex align-items-center gap-3">
                    <div className="d-flex gap-3 p-2 bg-white rounded align-items-center justify-content-center">
                      <img
                        className="w-[28.5px] h-[28.5px]"
                        alt={`${info.type} icon`}
                        src={info.icon}
                      />
                    </div>

                    <div className="flex flex-col w-[179px] items-start">
                      <div className="poppins-semibold text-white text-base font-16 ">
                        {info.type}
                      </div>

                      {info.type !== "Social Media" ? (
                        <div className="text-white text-white font-16 poppins-light">
                          {info.value}
                        </div>
                      ) : (
                        <div className="d-flex align-items-center gap-2 w-100">
                          {info.values?.map((value, idx) => (
                            <div
                              key={idx}
                             className="text-white text-white font-16 poppins-light"
                            >
                              {value}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
         
        </Card>
    </div>
  );
}

export default ContactUs;
